import { useState, useEffect } from "react";

import "./Hero07.css";

function Hero07() {
  return (
    <div className="Hero07 section" id="Hero07">
      <div className="container">
        <div className="Hero07-box">
          <h1>Request an Invitation</h1>
          <p>
            To maintain the elite standard of our verified network, Served
            accepts new clients by application or direct referral only.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hero07;
